import React, { useState, useEffect } from 'react';
import { AiOutlineRight } from 'react-icons/ai';
import Link from 'common/components/tags/link';
import CategoryLink from 'common/components/UI/sideBarLinks/SideBarLinks';
import Button from 'common/components/tags/button/Button';
import Box from 'common/components/UI/box/Box';
import Typography from 'common/components/tags/typography/Typography';
import Skeleton from 'common/components/npm/skeleton/Skeleton';
import { useHelpContext } from 'common/context/help-context';

const PostList = () => {
  const HelpCtx = useHelpContext();
  const [loadMore, setLoadMore] = useState(false);
  const [links, setLinks] = useState<{ title: string; href: string }[]>([]);

  useEffect(() => {
    if (HelpCtx?.categories)
      setLinks(
        HelpCtx?.categories?.map((item) => {
          return { title: item.title, href: `/help/categories/` + item.id };
        })
      );
  }, [HelpCtx?.categories]);

  return (
    <section className='md:container md:max-w-[100%]'>
      <div className='grid grid-cols-7 md:py-5 xl:grid-cols-10'>
        <div className='container col-span-7 md:col-span-2 md:m-0 md:max-w-full md:p-0 '>
          <CategoryLink
            title='FAQs'
            titleClassName='capitalize'
            links={links}
          />
        </div>
        <Box
          className={
            'col-span-7 rounded-none md:col-span-5 md:rounded-4 xl:col-span-8'
          }
        >
          {!HelpCtx?.loading && (
            <div className='flex flex-col justify-start md:flex-row md:items-center md:pb-[1rem] xl:pb-[1rem]'>
              <Typography tag='h3' className='md:pb-[1rem] xl:pb-[3rem]'>
                {HelpCtx?.category}
              </Typography>
              <p
                className='text-[1.6rem] font-bold text-primary md:pl-[1.8rem] md:text-[1rem]
            md:font-normal xl:text-[1.4rem]'
              >
                {HelpCtx?.faqs?.length} Posts
              </p>
            </div>
          )}
          {!HelpCtx?.faqs || HelpCtx.loading ? (
            [...Array(6)].map((_, index) => <MySkeleton key={index} />)
          ) : (
            <>
              {loadMore
                ? HelpCtx?.faqs
                    .slice(0, 10)
                    .map((item) => <PostItem key={item.id} {...item} />)
                : HelpCtx?.faqs.map((item) => (
                    <PostItem {...item} key={item.id} />
                  ))}
            </>
          )}
          {HelpCtx?.faqs && HelpCtx?.faqs?.length > 10 && (
            <Button
              label='More Posts'
              className='mt-4 pl-0'
              iconClassName='arrow-right'
              icon_align='right'
              variant='text-fill'
            />
          )}
        </Box>
      </div>
    </section>
  );
};

export default PostList;

const PostItem = ({ title, id }: FAQ) => {
  return (
    <h4
      className='flex items-center justify-between border-b border-gray4 border-opacity-40 py-8 font-medium text-black 
    last-of-type:border-none md:py-3 xl:py-7 '
    >
      <Link
        href={'/help/' + id}
        className='cursor-pointer text-[1.6rem] font-normal md:text-[1.2rem] xl:text-[2rem] normal-case'
      >
        {title}
      </Link>
      <Link
        href={'/help/' + id}
        className='cursor-pointer text-[1.6rem] font-normal md:text-[1.2rem] xl:text-[2rem]'
      >
        <AiOutlineRight color='#006FFD' />
      </Link>
    </h4>
  );
};

const MySkeleton = () => {
  return (
    <div className='border-b border-gray4 border-opacity-40 py-8 last-of-type:border-none md:px-[0.6rem] md:py-3 xl:py-7 xl:px-5'>
      <Skeleton className='h-9 w-full rounded-1 md:w-2/3' />
    </div>
  );
};
